document.addEventListener('DOMContentLoaded', () => {
  const selectors = document.querySelectorAll('.bundle-selector-3tabs');

  // 🧠 Fix for missing product IDs in Shopify preview mode
  async function hydrateMissingProductIds(container) {
  const needHydration =
    !container.dataset.bundleProduct1 ||
    !container.dataset.bundleProduct2 ||
    !container.dataset.kitchenProduct1;

  if (!needHydration) return;

  console.warn('⚠️ Missing product IDs — fetching dynamically...');

  const handles = {
    bundle1: 'test-product',
    bundle2: 'clearflow-filter-pack',
    kitchen1: 'test-product',
    kitchen2: 'clearflow-filter-pack',
    kitchen3: 'kitchen-extension'
  };

  try {
    const products = await Promise.all(
      Object.values(handles).map(h =>
        fetch(`/products/${h}.js`).then(r => r.json())
      )
    );

    const [b1, b2, k1, k2, k3] = products;

    // ✅ Hydrate variant IDs
    let clf_b1 = b1?.variants.find(v => v.title === 'Single');
    let clf_b2 = b2?.variants.find(v => v.title === 'Filter Pack');
    let clf_b1_id = clf_b1?.id || '';
    let clf_b2_id = clf_b2?.id || '';
    let clf_b1_price = clf_b1?.price / 100 || 0;
    let clf_b2_price = clf_b2?.price / 100 || 0;
    console.log(`${clf_b1_id}, ${clf_b2_id}, ${clf_b1_price}, ${clf_b2_price}`);

    // container.dataset.bundleProduct1 = b1?.variants?.[0]?.id || '';
    // container.dataset.bundleProduct2 = b2?.variants?.[0]?.id || '';
    container.dataset.bundleProduct1 = clf_b1_id;
    container.dataset.bundleProduct2 = clf_b2_id;
    container.dataset.kitchenProduct1 = k1?.variants?.[0]?.id || '';
    container.dataset.kitchenProduct2 = k2?.variants?.[0]?.id || '';
    container.dataset.kitchenProduct3 = k3?.variants?.[0]?.id || '';

    // ✅ Hydrate correct prices directly from variants
    // container.dataset.bundlePrice1 = (b1?.variants?.[0]?.price / 100) || 0;
    // container.dataset.bundlePrice2 = (b2?.variants?.[0]?.price / 100) || 0;
    container.dataset.bundlePrice1 = clf_b1_price;
    container.dataset.bundlePrice2 = clf_b2_price;
    container.dataset.kitchenPrice1 = (k1?.variants?.[0]?.price / 100) || 0;
    container.dataset.kitchenPrice2 = (k2?.variants?.[0]?.price / 100) || 0;
    container.dataset.kitchenPrice3 = (k3?.variants?.[0]?.price / 100) || 0;

    console.log('✅ Hydrated variant IDs & prices:', {
      bundle1: container.dataset.bundleProduct1,
      bundle2: container.dataset.bundleProduct2,
      kitchen1: container.dataset.kitchenProduct1,
      kitchen2: container.dataset.kitchenProduct2,
      kitchen3: container.dataset.kitchenProduct3
    });
  } catch (err) {
    console.error('❌ Failed to fetch product data:', err);
  }
}



  selectors.forEach((container) => {
    (async () => {
      await hydrateMissingProductIds(container);

      const tabs = container.querySelectorAll('.bundle-tab');
      const contents = container.querySelectorAll('.bundle-content');
      const qtyMinus = container.querySelector('.qty-btn.minus');
      const qtyPlus = container.querySelector('.qty-btn.plus');
      const qtyCount = container.querySelector('.qty-count');
      const priceEl = container.querySelector('.add-to-cart-btn .price');
      const addBtn = container.querySelector('.add-to-cart-btn');

      let currentPrice = 0;

      // 🧮 Helper: instant total calculation
      const calculateBundlePrice = () => {
        const p1 = parseFloat(container.dataset.bundlePrice1) || 0;
        const p2 = parseFloat(container.dataset.bundlePrice2) || 0;
        return p1 + p2;
      };

      const calculateKitchenPrice = () => {
        const p1 = parseFloat(container.dataset.kitchenPrice1) || 0;
        const p2 = parseFloat(container.dataset.kitchenPrice2) || 0;
        const p3 = parseFloat(container.dataset.kitchenPrice3) || 0;
        return p1 + p2 + p3;
      };

      // 🟦 Update button price instantly
      const updateButtonPrice = () => {
        const qty = parseInt(qtyCount.textContent) || 1;
        const activeTab = container.querySelector('.bundle-tab.active');
        const tabTarget = activeTab?.dataset.target;

        let totalPrice = 0;
        if (tabTarget === 'filter') totalPrice = currentPrice;
        if (tabTarget === 'bundle') totalPrice = calculateBundlePrice();
        if (tabTarget === 'kitchen') totalPrice = calculateKitchenPrice();

        const grandTotal = (totalPrice * qty).toFixed(2);
        const dynamicPriceEl = container.querySelector('.add-to-cart-btn .price');
        if (dynamicPriceEl) dynamicPriceEl.textContent = `${grandTotal}`;
      };

      // 🟦 Tab switching
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          tabs.forEach((t) => t.classList.remove('active'));
          contents.forEach((c) => c.classList.remove('active'));
          tab.classList.add('active');

          const target = tab.getAttribute('data-target');
          const activeContent = container.querySelector(`#${target}`);
          if (activeContent) activeContent.classList.add('active');

          qtyCount.textContent = '1';
          updateButtonPrice();
        });
      });

      // 🟦 Variant selection
      const variantCards = container.querySelectorAll('.variant-card');
      variantCards.forEach((card) => {
        card.addEventListener('click', () => {
          variantCards.forEach((c) => c.classList.remove('active'));
          card.classList.add('active');
          console.log(card);
          dropdown = container.querySelector('.dropdown-items');
          if (window.ShopifyLocale.iso === 'ar') {
            switch (Array.from(card.parentNode.children).indexOf(card)) {
              case 0:
                    dropdown.innerHTML = `<ul>
                    <li>
                      <div class="custom-checkmark">✓</div>
                      <span class="label-text">1 رأس ترشيح</span>
                    </li>
                    <li>
                      <div class="custom-checkmark">✓</div>
                      <span class="label-text">1 خرطوشة (تدوم من 4 إلى 6 أسابيع)</span>
                    </li>
                    <li>
                      <div class="custom-checkmark">✓</div>
                      <span class="label-text">محولات من 6 قطع</span>
                    </li>
                      <li>
                      <div class="custom-checkmark">✓</div>
                      <span class="label-text">1مفتاح عالمي لمهوية الهواء</span>
                    </li>
                  </ul>`
                            break;
                          case 1:
                            dropdown.innerHTML = `<ul>
                    <li>
                      <div class="custom-checkmark">✓</div>
                      <span class="label-text">2 رؤوس ترشيح</span>
                    </li>
                    <li>
                      <div class="custom-checkmark">✓</div>
                      <span class="label-text">2 عبوتان (تدوم كل منهما من 4 إلى 6 أسابيع)</span>
                    </li>
                    <li>
                      <div class="custom-checkmark">✓</div>
                      <span class="label-text">2 مجموعتان من المحولات، كل مجموعة تحتوي على 6 قطع</span>
                    </li>
                      <li>
                      <div class="custom-checkmark">✓</div>
                      <span class="label-text">2 مفتاحان عالميان لتهوية الهواء</span>
                    </li>
                  </ul>`
                            break;
                          case 2:
                            dropdown.innerHTML = `<ul>
                    <li>
                      <div class="custom-checkmark">✓</div>
                      <span class="label-text">3 رؤوس ترشيح</span>
                    </li>
                    <li>
                      <div class="custom-checkmark">✓</div>
                      <span class="label-text">3 خراطيش (تدوم كل منها من 4 إلى 6 أسابيع)</span>
                    </li>
                    <li>
                      <div class="custom-checkmark">✓</div>
                      <span class="label-text">3 مجموعات من محولات الطاقة، كل مجموعة تحتوي على 6 قطع</span>
                    </li>
                      <li>
                      <div class="custom-checkmark">✓</div>
                      <span class="label-text">3 مفاتيح تهوية عالمية</span>
                    </li>
                  </ul>`
                            break;
                  }
                } else {
          switch (Array.from(card.parentNode.children).indexOf(card)) {
            
            case 0:
              dropdown.innerHTML = `<ul>
      <li>
        <div class="custom-checkmark">✓</div>
        <span class="label-text">1 Filterhead</span>
      </li>
      <li>
        <div class="custom-checkmark">✓</div>
        <span class="label-text">1 Cartridge (lasts 4–6 weeks)</span>
      </li>
      <li>
        <div class="custom-checkmark">✓</div>
        <span class="label-text">6pc Adapters</span>
      </li>
        <li>
        <div class="custom-checkmark">✓</div>
        <span class="label-text">1 Universal Aerator Keys</span>
      </li>
    </ul>`
              break;
            case 1:
              dropdown.innerHTML = `<ul>
      <li>
        <div class="custom-checkmark">✓</div>
        <span class="label-text">2 Filterheads</span>
      </li>
      <li>
        <div class="custom-checkmark">✓</div>
        <span class="label-text">2 Cartridges (lasts 4–6 weeks each)</span>
      </li>
      <li>
        <div class="custom-checkmark">✓</div>
        <span class="label-text">2 sets of 6pc Adapters</span>
      </li>
        <li>
        <div class="custom-checkmark">✓</div>
        <span class="label-text">2 Universal Aerator Keys</span>
      </li>
    </ul>`
              break;
            case 2:
              dropdown.innerHTML = `<ul>
      <li>
        <div class="custom-checkmark">✓</div>
        <span class="label-text">3 Filterheads</span>
      </li>
      <li>
        <div class="custom-checkmark">✓</div>
        <span class="label-text">3 Cartridges (lasts 4–6 weeks each)</span>
      </li>
      <li>
        <div class="custom-checkmark">✓</div>
        <span class="label-text">3 sets of 6pc Adapters</span>
      </li>
        <li>
        <div class="custom-checkmark">✓</div>
        <span class="label-text">3 Universal Aerator Keys</span>
      </li>
    </ul>`
              break;
              }
            }
          currentPrice = parseFloat(card.dataset.price) || 0;
          updateButtonPrice();
        });
      });

      // 🟦 Quantity control
      if (qtyMinus && qtyPlus && qtyCount) {
        qtyMinus.addEventListener('click', () => {
          let count = parseInt(qtyCount.textContent) || 1;
          if (count > 1) qtyCount.textContent = count - 1;
          updateButtonPrice();
        });
        qtyPlus.addEventListener('click', () => {
          let count = parseInt(qtyCount.textContent) || 1;
          qtyCount.textContent = count + 1;
          updateButtonPrice();
        });
      }

      // 🟦 Add to cart logic
      if (addBtn) {
        addBtn.addEventListener('click', async () => {
          const activeTab = container.querySelector('.bundle-tab.active');
          const tabTarget = activeTab?.getAttribute('data-target');
          const qty = parseInt(qtyCount.textContent) || 1;
          const cartDrawer = document.querySelector('cart-drawer');
          let items = [];

          // BOLD UPSELL - Custom code Start here
          // this code search for default variant id input and quantity input
          let default_variant_input = addBtn.closest('.product').querySelector(`input.product-variant-id`) || null;
          let default_quantity_input = addBtn.closest('.product').querySelector(`input[name="quantity"]`) || null; 
          // BOLD UPSELL - Custom code End here

          if (tabTarget === 'filter') {
            console.log('filters selected'); // temp console to debug

            const activeCard = container.querySelector('.variant-card.active');
            if (!activeCard) return;

            console.log('filters active card'); // temp console to debug

            items.push({ id: activeCard.dataset.variantId, quantity: qty });

            // BOLD UPSELL - Custom code Start here
            // If disabled this portion of the code, the bold upsell popup will not work.
            default_variant_input && (default_variant_input.value = activeCard.dataset.variantId);
            default_quantity_input && (default_quantity_input.value = qty);

            console.log(activeCard); // temp console to debug
            console.log(activeCard.dataset.variantId); // temp console to debug
            console.log(qty); // temp console to debug
            console.log(default_variant_input); // temp console to debug
            console.log(default_quantity_input); // temp console to debug

            setTimeout(() => {
              const addToCartBtn = document.querySelector(
                'button.atc-button.product-form__submit.bold_clone[name="add"]'
              );
  
              if (addToCartBtn) {
                addToCartBtn.dispatchEvent(
                  new MouseEvent('click', { bubbles: true, cancelable: true })
                );
              }
            },100);
            return;
            // BOLD UPSELL - Custom code End here
          }

          if (tabTarget === 'bundle') {
            const id1 = container.dataset.bundleProduct1;
            const id2 = container.dataset.bundleProduct2;
            if (id1) items.push({ id: id1, quantity: qty });
            if (id2) items.push({ id: id2, quantity: qty });
          }

          if (tabTarget === 'kitchen') {
            const ids = [
              container.dataset.kitchenProduct1,
              container.dataset.kitchenProduct2,
              container.dataset.kitchenProduct3
            ];
            ids.forEach((id) => id && items.push({ id, quantity: qty }));
          }

          if (!items.length) {
            console.warn('⚠️ No products found.');
            return;
          }

          try {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items })
            });

            const sections = cartDrawer?.getSectionsToRender?.() || [];
            const sectionIds = sections.map((s) => s.id).join(',');
            const data = await fetch(`/cart?sections=${sectionIds}`).then((r) => r.json());

            const parsedState = { sections: {} };
            Object.keys(data).forEach((sectionId) => {
              const html = data[sectionId];
              const textarea = document.createElement('textarea');
              textarea.innerHTML = html;
              const decoded = textarea.value;
              const parser = new DOMParser();
              const doc = parser.parseFromString(decoded, 'text/html');
              const extracted =
                doc.querySelector('#CartDrawer') ||
                doc.querySelector('#cart-drawer') ||
                doc.querySelector('.cart-drawer') ||
                doc.body;
              extracted.querySelectorAll('script, style').forEach((el) => el.remove());
              parsedState.sections[sectionId] = extracted.innerHTML.trim();
            });

            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(parsedState);
              cartDrawer.classList.remove('is-empty');
            }

            addBtn.disabled = true;
            addBtn.innerHTML = 'Added ✓';
            // setTimeout(() => {
            //   addBtn.disabled = false;
            //   addBtn.innerHTML = `Add to cart • <span class="price"></span>`;
            //   updateButtonPrice();
            // }, 1200);

            const cartData = await fetch('/cart.js').then((r) => r.json());
            document
              .querySelectorAll('[data-cart-count], .cart-count-bubble')
              .forEach((el) => (el.textContent = cartData.item_count));

            if (cartDrawer && !cartDrawer.classList.contains('active')) cartDrawer.open();
          } catch (err) {
            console.error('❌ Add to cart failed:', err);
          }
        });
      }

      // 🟩 Initialize on load
      const activeCard = container.querySelector('.variant-card.active');
      if (activeCard) currentPrice = parseFloat(activeCard.dataset.price) || 0;
      updateButtonPrice();
    })();
  });
});
